import React, { useState, useEffect } from "react";
import "./myDevices.css"; // Import the CSS file
import axios from "axios";
import BASE_URL from "../../config";

const CallLogs = () => {
  const [devices, setDevices] = useState([]); // State to store devices
  const [deviceId, setDeviceId] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState(""); // "success" or "error"

  // Fetch devices function
  const fetchDevices = async () => {
    try {
      const token = localStorage.getItem("jwt_token");

      if (!token) {
        setMessage("Please log in first.");
        setMessageType("error");
        return;
      }

      const response = await axios.post(
        `${BASE_URL}/api/get_cust_calls/`,
        {}, // Empty body for a POST request (assuming GET is not required)
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`, // Send JWT token
          },
        }
      );

      if (response.status === 200) {
        setDevices(response.data); // Update devices state with the response data
      } else {
        setMessage("Error: " + response.data.detail);
        setMessageType("error");
      }
    } catch (error) {
      console.error(error);
      setMessage("No calls Fetched");
      setMessageType("error");
    }
  };

  // Fetch devices when the component mounts
  useEffect(() => {
    fetchDevices();
  }, []); // Empty dependency array ensures this runs once when component mounts

  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => setMessage(""), 3000); // Hide message after 3s
      return () => clearTimeout(timer);
    }
  }, [message]);


  return (
    <div className="my-devices-container">
      <h2 className="my-devices-title">My Call Logs</h2>

      {/* List Table */}
      <div className="mt-6 overflow-x-auto">
        <table className="device-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Call From</th>
              <th>Call To</th>
              <th>Date/Time</th>
              
            </tr>
          </thead>
          <tbody>
            {devices.length > 0 ? (
              devices.map((device) => (
                <tr key={device.id}>
                  <td>{device.id}</td>
                  <td>{device.call_from}</td>
                  <td>{device.call_to}</td>
                  <td>{device.date_time}</td>
                  
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="no-devices">
                  No call data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CallLogs;
